import {Style, Fill, Stroke, Icon, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class ObstacleLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'obstacle';
        settings["api_endpt"] = "ObstacleJSON.php";
        if( settings['labels'] == undefined ) settings["labels"] = false;
        if( settings['scale'] == undefined ) settings["scale"] = 1;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        return url.toString();
    }

    getIconSize( feature ){
        return this.settings['scale']*20;
    }

    getIcon( feature ){
        let params = "";
        if( this.property(feature,'type') == "TWRH" )
            params = params + "code=OBS-H&color=104090";
        if( this.property(feature,'type') == "TWRM" || 
                this.property(feature,'type') == "TWRL" )
            params = params + "code=OBS-L&color=104090";
        if( this.property(feature,'type') == "WIND" )
            params = params + "code=WNDFM&color=104090";
        if( this.settings['scale'] != 1 )
            params = params + "&scale="+this.settings['scale'];
        return this.icon_path+'/wxicon.php?'+params;
    }

    getLabel( feature ){
        let str = "";
        if( this.settings['labels'] == true ){
            str = Math.round(this.property(feature,'elev')*3.28)+"";
        }
        return str;
    }

    getPopupText( feature ){
        let type = this.property(feature,'type');
        if( type == "TWRH" ) type = "Tower Hi";
        if( type == "TWRM" ) type = "Tower Mid";
        if( type == "TWRL" ) type = "Tower Lo";
        if( type == "WIND" ) type = "Wind Farm";
        if( type == "CAT" ) type = "Catenary";
        let text = this.popupTitle( "OBSTACLE", type );
        let name = this.property(feature,'name');
        text += this.popupData( "Type", name );
        if( name.includes( "LGT-R" ))
            text += this.popupData( "Lighting", "Red" );
        else if( name.includes( "LGT-D" ))
            text += this.popupData( "Lighting", "Med intensity white strobe and red" );
        else if( name.includes( "LGT-H" ))
            text += this.popupData( "Lighting", "High intensity white strobe and red" );
        else if( name.includes( "LGT-M" ))
            text += this.popupData( "Lighting", "Med intensity white strobe" );
        else if( name.includes( "LGT-S" ))
            text += this.popupData( "Lighting", "High intensity white strobe" );
        else if( name.includes( "LGT-F" ))
            text += this.popupData( "Lighting", "Flood" );
        else if( name.includes( "LGT-C" ))
            text += this.popupData( "Lighting", "Catenary" );
        else if( name.includes( "LGT-W" ))
            text += this.popupData( "Lighting", "Synchronized red" );
        else if( name.includes( "LGT-L" ))
            text += this.popupData( "Lighting", "Unknown type" );
        var htm = this.property(feature,'elev');
        var htf = Math.round(htm*3.28);
        text += this.popupData( "Elevation", htm+"m ("+htf+"ft)" );
        if( this.property(feature,'height') != undefined ){
            var htm = this.property(feature,'height');
            var htf = Math.round(htm*3.28);
            text += this.popupData( "Height AGL", htm+"m ("+htf+"ft)" );
        }
        text += this.popupEnd();
        return text;
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }
        let style = new Style({
                "image": icon,
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": "black"
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 }),
                        "offsetX": -20,
                        "offsetY": 12
                        })
                });
        return style;
    }

}
